module.exports = __webpack_public_path__ + "img/Dantam Makeover 16.197fda11.jpg";